<h2 class="title">Lesezeichen</h2>
<ul>
    @for (favorite of favoritesBeforeFirstChapter; track favorite) {
        <li>
            <sidebar-single-page-favorite [pageFavorite]="favorite"></sidebar-single-page-favorite>
        </li>
    }
</ul>
@if (pageFavorites && pageFavorites.length > 0) {
    <ul>
        @for (chapterFavorites of chapterPageFavorites; track chapterFavorites) {
            <li>
                @if (chapterFavorites.pageFavorites.length > 0) {
                    <app-main-chapter-heading [chapter]="chapterFavorites.chapter"></app-main-chapter-heading>
                    <ul>
                        @for (favorite of chapterFavorites.pageFavorites; track favorite) {
                            <li>
                                <sidebar-single-page-favorite [pageFavorite]="favorite"></sidebar-single-page-favorite>
                            </li>
                        }
                    </ul>
                }
            </li>
        }
    </ul>
}

@if (!pageFavorites || pageFavorites.length === 0) {
    <p>Keine Lesezeichen vorhanden</p>
}
